export const NOT_FOUND_ERROR_PAGE_ROUTE = "/page-introuvable"
export const SERVER_ERROR_PAGE_ROUTE = "/page-introuvable"
export const NETWORK_ERROR_PAGE_ROUTE = "/page-introuvable"